import * as React from "react";
const SvgCircleFilled = (props) => (React.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 14 14" }, props),
    React.createElement("path", { fill: "currentColor", d: "M0 7a7 7 0 1 0 14 0A7 7 0 1 0 0 7" })));
export default SvgCircleFilled;
